import React from 'react'
import { CreateSubscription } from '../components'

export default function AddSubscription() {
    return (
        <div>
            <CreateSubscription />
        </div>
    )
}
